import React, { useState, useEffect } from 'react';
import { tagColors } from "../lib/globalData"
import Slider from '../lib/slider';
import { Pens, PrintModi, sizesSticker, sizesImg } from '../lib/constants';
import moment from 'moment';

const Biblio = props => {
  const { dataprovider, staticel, userinfo, setUserField, params, is_dev } = props;
  require('moment/locale/de');
  moment.locale('de');
  
  var get = {};
  if (params) {
    var parts = params.split("&");
    for (var i = 0; i < parts.length; i++) {
      var temp = parts[i].split("=");
      get[decodeURIComponent(temp[0])] = decodeURIComponent(temp[1]);
    }
  }
  
  const [biblio, setBiblio] = useState(false);
  const [search, setSearch] = useState('');
  const [fiTag, setFiTag] = useState(-1);
  const [fiProjekte, setFiProjekte] = useState(!!get.proj);
  const [sort, setSort] = useState('Neuheit');
  const [sendID, setSendID] = useState(0);
  const [sendEmail, setSendEmail] = useState('');
  const [sendResp, setSendResp] = useState({});
  const [delProd, setDelProd] = useState({});
  const [addCart, setAddCart] = useState(0);
  const [size, setSize] = useState('20');
  const [numPrint, setNumPrint] = useState(1);
  const [hell, setHell] = useState('0');
  const [extraParam, setExtraParam] = useState('');
  const [anz, setAnz] = useState(1);
  const [printID, setPrintID] = useState(0);
  const [progress, setProgress] = useState(false);
  const [download, setDownload] = useState(false);
  
  useEffect(() => {
    dataprovider.getList('biblio', {filter:{search:search, proj:fiProjekte, tag:fiTag}, sort:sort}, setBiblio);
  }, [dataprovider, fiProjekte, fiTag, search, sort, delProd]);
  
  const handleSearch = ev => {
    setSearch(ev.target.value);
  }
  const handleSort = ev => {
    setSort(ev.target.value);
  }
  const handleFiProjketeClick = ev => {
    setFiProjekte(!fiProjekte);
  }
  const handleFiTag = (k) => ev => {
    setFiTag(k);
    setFiProjekte(k>-1);
  }
  
  const updateRow = (data) => {
    const d = [];
    biblio.map(el=>{
      const row = {...el};
      if (el.id===data.id) {
        row.sync = data.sync
        row.tag = data.tag
      }
      d.push(row);
      return true;
    })
    setBiblio(d);
  }
  const handleToggleClick = (id, sync, tag) => (ev) => {
    dataprovider.update('biblio/'+id, {sync, tag}, updateRow);
  }
    
  const handleSendClick = (id) => (ev) => {
    setSendID(id)
  }
  const CloseSenddModal = (ev) => {
    setSendID(0)
    setSendResp({});
  }
  const handleChangeSendEmail = ev => {
    setSendEmail(ev.target.value);
  }
  const SendProject = (ev) => {
    ev.preventDefault();
    const re = /^((([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})),?)+$/;
    const mails = sendEmail.replaceAll(' ', '');
    if (mails && re.test(mails.toLowerCase())) {
      setSendResp({ok:false});
      dataprovider.getRow('project/', sendID, 'send='+sendEmail, setSendResp);
    }
    else {
      setSendResp({ok:false, err:"Adresse(n) nicht gültig."});
    }
  }
  const handleDelClick = (id, name) => (ev) => {
    setDelProd({id: -id, name:name})
  }
  const CloseDelModal = (ev) => {
    setDelProd({})
  }
  const DelProduct = (ev) => {
    dataprovider.del('asset/'+delProd.id, {}, CloseDelModal);
  }
  
  const handleSetAddCart = proid => ev => {
    setSize(biblio.find(el=>el.id===proid)?.last_size || '20');
    if (proid!==0) {
      setProgress(false);
      setDownload(false);
    }
    setAddCart(proid);
  }
  const handleSetPrintID = proid => ev => {
    setSize(biblio.find(el=>el.id===proid)?.last_size || '20');
    if (proid!==0) {
      setProgress(false);
      setDownload(false);
    }
    setPrintID(proid);
  }
  const handleSize = ev => {
    setSize(ev.target.value);
  }
  const handlePen = ev => {
    setUserField('lastpen', ev.target.value);
  }
  const handlePrintMode = ev => {
    setUserField('printmode', ev.target.value);
  }
  const handleNumPrint = ev => {
    setNumPrint(ev.target.value);
  }
  const handleExtraParam = ev => {
    setExtraParam(ev.target.value);
  }
  const handleHell = ev => {
    setHell(ev.target.value);
  }
  const handleAnz = ev => {
    setAnz(ev.target.value);
  }
  const updateCartNum = (data) => {
    if (window.updateCart) {
      window.updateCart(data.cnt);
    }
  }
  const handleAddCart = ev => {
    if (userinfo.lastpen==='-') {
      alert('Bitte Stifthersteller wählen');
    }
    else {
      dataprovider.insert('basket', {data: {[-addCart]:anz}, pen:userinfo.lastpen+'/'+size}, updateCartNum);
      setAddCart(0);
    }
  }

  const pdfFinish = (res) => {
    setDownload(res);
  }
  const pdfErstellen = (vorschau) => {
    setProgress(0);
    const printmode = vorschau?'0111':userinfo.printmode;
    let extra = '';
    if (GetAttribute(printID, 'has_image')) {
      extra += "&hell="+hell;
    }
    if (vorschau) {
      extra += "&vorschau=1";
    }
    const proid = printID?printID:addCart;
    setBiblio(biblio.map(el=>el.id===proid?{...el, last_size:size}:el));
    dataprovider.getRow('output', proid, "size="+size+"&type="+userinfo.lastpen+"&mode="+printmode+"&num="+(printID?numPrint:anz)+extraParam+extra, pdfFinish);
    setTimeout(GetProgress, 500);
  }
  const UpdateProgress = (res) =>{
    const v = res.value;
    if (v) {
      const s = v.split('/');
      if (s.length>1) {
        const max = parseInt(s[1]);
        if (max > 0) {
          const pos = parseInt(s[0]);
          setProgress(Math.round(100/max * pos));
          if (pos < max) {
            setTimeout(GetProgress, 500);
          }
        }
      }
    }
  }

  const GetProgress = () => {
    dataprovider.getRow('progress', 0, false, UpdateProgress);
  }

  const GetName = (id) => {
    if (!biblio || biblio.length < 1) return null;
    const p = biblio.find((el)=>id<0?el.id_product===-id:el.id===id);
    if (!p || !p.name) return null;
    return <>&laquo;{p.name}&raquo; </>;
  }
  
  const GetAttribute = (id, attr) => {
    if (!biblio || biblio.length < 1) return null;
    const p = biblio.find((el)=>id<0?el.id_product===-id:el.id===id);
    if (!p || !p[attr]) return null;
    return p[attr];
  }
  
  if (biblio === false) return null;
  // <option value="Beliebtheit">Beliebtheit</option>
  if (!userinfo || !userinfo.id) {
    return (
      <>
        <Slider staticel={staticel} page={10} is_dev={is_dev} />
        <div className="container mt-5">
          <div className="row ms-0 mb-1 mt-3 p-3" style={{backgroundColor:'#E3F0F6', borderRadius:'15px'}}>
            <div className="col">
              <h4>Verwalte hier deine Hörinhalte</h4>
              <p>Du musst dich <a href="/app#login">anmelden</a> oder <a href="/app#register">registrieren</a>.</p>
            </div>
          </div>
        </div>
      </>
    )
  }

  if (!biblio.length && search==='' && !fiProjekte && fiTag<0) {
    return (
      <>
        <Slider staticel={staticel} page={10} is_dev={is_dev} />
        <div className="container mt-5">
          <div className="row ms-0 mb-1 mt-3 p-3" style={{backgroundColor:'#E3F0F6', borderRadius:'15px'}}>
            <div className="col">
              <h4>Keine Hörinhalte gespeichert</h4>
              <p>Hole dir im <a href="/app#shop">Shop</a> Hörprodukte oder erstelle im <a href="/app#creator">Creator</a> eigene Projekte.</p>
            </div>
          </div>
        </div>
      </>
    )
  }

  const proj = biblio.find((e)=>e.id===addCart);
  const actId = printID!==0?printID:(addCart!==0?addCart:0);
  const hasImage = !!GetAttribute(actId, 'has_image');  
  let anzSticker = 0;
  let anzBogen = 0;
  if (hasImage && size.includes("x")) {
    anzSticker = (proj?proj.stickercount:0)
    const s = size.split("x");
    anzBogen = Math.ceil(anzSticker / (s[0]*s[1])) * anz;
    anzSticker = (proj?proj.stickercount:0) * anz;
  }
  else {
    anzSticker = (proj?proj.stickercount:0) * anz;
    anzBogen = Math.ceil(anzSticker / (size==="60"?12:(size==="40"?24:88)));
  }
  if (actId!==0) {
    if (hasImage && size==="20") {
      setSize('4x6');
    }
    if (!hasImage  && typeof size==="string" && size.includes("x")) {
      setSize('20');
    }
  }
  return (
    <>
      <Slider staticel={staticel} page={10} is_dev={is_dev} />
      <div className="container pt-5 ps-1">
        <div className="mb-2 d-flex"> 
          <div className="input-group" style={{width:"15em"}}>
            <input className="form-control border-end-0 border" type="search" placeholder="Suche" value={search} id="example-search-input" onChange={handleSearch} />
            <span className="input-group-append">
              <button className="btn btn-outline-secondary bg-white border-start-0 border-bottom-0 border ms-n5 me-3" style={{}} type="button">
                <i className="bi bi-search"></i>
              </button>
            </span>
          </div>
          <select className="form-select me-3" value={sort} onChange={handleSort}  style={{display:"inline-block", width:"auto"}}>
            <option value="Neuheit">Neuheit</option>
            <option value="Titel">Titel</option>
          </select>
          <div className="dropdown tagfilter me-3">
            <button className="btn btn-light dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
            <i className={'bi bi-bookmark'+(fiTag>-1?'-fill':'')} style={{color:tagColors[fiTag]}}></i> Filter
            </button>
            <ul className="dropdown-menu">
              <li onClick={handleFiTag(-1)}><i className="bi bi-bookmark"></i></li>
          {tagColors.map((col, k)=> (
              <li key={k} onClick={handleFiTag(k)}><i className="bi bi-bookmark-fill" style={{color:col}}></i></li>
          ))}
            </ul>
          </div>
          <button type="button" className={"btn btn-"+(fiProjekte?"primary":"secondary")+" me-2"} onClick={handleFiProjketeClick} >Meine Projekte</button>
        </div>
      </div>
      <div className="bg-light">
        <div className="container mt-2">
      {!biblio.length && 
        <div className="row">
          <div className="row ms-0 mb-1 mt-3 p-3" style={{backgroundColor:'#f2f2f2', borderRadius:'15px'}}>
            Kein passender Inhalt für die Suche gefunden.
          </div>
        </div>
        
        
      }
          <div className="row">
      {biblio.map(el => {
        const is_hoerpojekt = el.tiptoi_id>=700 && el.tiptoi_id<900 && el.id>0;
        return (
            <div className="row ms-0 mb-1 mt-3 p-3" style={{backgroundColor:el.id>0?(is_hoerpojekt?'#eee0ec':'#E3F0F6'):'#f2f2f2', borderRadius:'15px'}} key={el.id}>
              <div className="col">
                <h4>{el.name}</h4>
            {el.claim!=='' && <h5>{el.claim}</h5>}
            {el.edit && el.id > 0?('Letzte Änderung, '+moment(el.edit).format('dd, Do MMM YYYY HH:mm')):''}
              </div>
              <div className="col-auto align-self-center">
                {el.tag>-1 && <i className="bi bi-bookmark-fill" style={{fontSize:'1.5em', color:tagColors[el.tag], cursor:'pointer'}} onClick={handleToggleClick(el.id, el.sync, (el.tag+1)%6)}></i>}
              </div>
        {el.paid==="1"?
            <>
              <div className="col-auto p-0">
              {el.id > 0 ?
                <>
                <a href={"#creator/"+el.id} className="btn btn-secondary ms-1 d-block py-1 px-2" title="Projekt bearbeiten"><i className="bi bi-pencil fs-5"></i></a>
                {(el.tiptoi_id<700 || el.tiptoi_id>899) &&
                  <button type="button" className="btn btn-secondary ms-1 mt-2 py-1 px-2" onClick={handleSendClick(el.id)} title="Projekt teilen"><i className="bi bi-send fs-5"/></button>
                }
                </>
              :
                <>
                <a href={"/app#shop/s"+el.id_product} className="btn btn-secondary ms-1 d-block py-1 px-2" title="Produkt Infos"><i className="bi bi-info-circle fs-5"></i></a>
                <button type="button" className="btn btn-secondary ms-1 mt-2 py-1 px-2" onClick={handleDelClick(el.id, el.name)} title="Produkt löschen"><i className="bi bi-trash fs-5"></i></button>
                </>
              }
              </div>
              <div className="col-auto p-0">
          {(el.id > 0 || el.print)?
                <button onClick={handleSetPrintID(el.id_product?-el.id_product:el.id_project)} className="btn btn-secondary ms-2 d-block py-1 px-2" target="_blank" rel="noreferrer" title="Sticker drucken"><i className="bi bi-printer fs-5"></i></button>
              :
                <div style={{height:'40px'}}></div>  
          }
          {el.id > 0?
                <button className="btn btn-secondary ms-2 mt-2 d-block py-1 px-2" data-bs-toggle="modal" onClick={handleSetAddCart(el.id)} title="Sticker bestellen"><i className="bi bi-cart2 fs-5"></i></button>
          :
                <a href={"/app#shop/s"+el.id_product} className="btn btn-secondary ms-2 mt-2 py-1 px-2" title="Sticker bestellen"><i className="bi bi-cart2 fs-5"></i></a>
          }
              </div>
              <div className="col-auto p-0">
                <button type="button" className="btn btn-secondary ms-2 ps-2 p-2 position-relative" onClick={handleToggleClick(el.id, el.sync<=0, el.tag)}  title="Stift sync aktivieren">
                  <svg width={window.innerWidth>=768?"70px":"21px"} height="70px" version="1.1" viewBox="0 0 20.8 23.6" xmlns="http://www.w3.org/2000/svg"><g stroke="#FFF" strokeMiterlimit="3.88"><ellipse transform="matrix(.851 .524 -.498 .867 0 0)" cx="17.1" cy="-5.8" rx="3.15" ry="1.72" fill="none" strokeLinecap="round" strokeWidth=".926"/><g stroklinejoin="round" strokeWidth=".926"><path d="m14.6 2.54c-4.7 8.29-6.83 12.8-7.87 17.9l2.28 1.35c3.84-3.37 6.68-8.47 11.1-16.1" fill="none" strokeLinecap="round"/><path d="m7.32 20.8-0.825 2.01 0.656 0.417 1.33-1.77c0.0459 0.0339-0.826-0.502-1.16-0.656z" fill="#FFF"/><path d="m1.29 2.79c1.42-2.74 4.69-2.82 6.54-0.299l0.921-0.546-0.185 2.05-1.79-0.827 1.05-0.674 0.408-0.241-0.00803 1.13-0.723-0.249 0.698-0.305" fill="none" strokeLinecap="round"/><path d="m7.86 5.79c-1.42 2.74-4.69 2.82-6.54 0.299l-0.921 0.546 0.185-2.05 1.79 0.827-1.05 0.674-0.408 0.241 0.00803-1.13 0.723 0.249-0.698 0.305" fill="none" strokeLinecap="round"/></g></g></svg>
                  {el.sync>0 && <i className="bi bi-check-lg position-absolute bottom-0 fs-3" style={{right:"0.25rem"}} />}
                </button>
              </div>
            </>
        :   <>  
          {el.id < 0 ?
              <div className="col-auto">Rechnung offen
                <a href={"#invoice/"+el.invoice} className="btn btn-secondary ms-4">Jetzt bezahlen</a><br/>
              </div>
          :
              <div className="col-auto">keine aktive Lizenz
            {userinfo.license>-1 ?
                <a href="/app#license" className="btn btn-secondary ms-4">Lizenz erneuern</a>
            :
                <a href="/app#shop/s114" className="btn btn-secondary ms-4">Lizenz kaufen</a>
            }
              </div>
          }
            </>
        }
            </div>
      )})}
          </div>
        </div>
      </div>
    {sendID > 0 && (
      <div className="modal fade show" style={{display:"block",backgroundColor: "rgba(0,0,0,0.5)"}}>
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Projekt {GetName(sendID)}teilen</h5>
              <button type="button" className="btn-close" onClick={CloseSenddModal}></button>
            </div>
            <div className="modal-body">
              <div style={{marginBottom:'8px'}}>Hinweis: Es ist untersagt Inhalte zu teilen, welche urheberrechtlich geschützt sind!</div>
              
        {sendResp.ok &&
              <h6>Dein Projekt wurde an {sendEmail} gesendet</h6>
        }
        {sendResp.ok && sendResp.unregistered.length>0 &&
              <h6 className="text-danger">Tippfehler? Folgende E-Mail Adresse ist nicht bei soundolino registriert: {sendResp.unregistered.join(", ")}</h6>
        }    
        {sendResp.err &&
              <h6 className="text-danger">{sendResp.err}</h6>
        }    
        {!sendResp.ok &&
              <form className="row g-3">
                <label htmlFor="SendEmail1" className="form-label">E-Mail Adresse (mehrere Adressen durch Komma trennen)</label>
                <input type="email" className="form-control" id="SendEmail1" value={sendEmail} onChange={handleChangeSendEmail} required style={{margin:0}} />
                <button type="submit" className="btn btn-primary mt-4" data-bs-dismiss="modal" onClick={SendProject}><i className="bi bi-send"/> Senden</button>
              </form>
        }
            </div>
          </div>
        </div>
      </div>
    )}
    {delProd.id > 0 && (
      <div className="modal fade show" style={{display:"block",backgroundColor: "rgba(0,0,0,0.5)"}}>
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">&laquo;{delProd.name}&raquo; aus Bibliothek entfernen</h5>
              <button type="button" className="btn-close" onClick={CloseDelModal}></button>
            </div>
            <div className="modal-body">
              <h6>Achtung: Hiermit wird das Produkt definitiv gelöscht.</h6>
              <button type="submit" className="btn btn-secondary mt-4 me-2" data-bs-dismiss="modal" onClick={CloseDelModal}><i className="bi bi-trash"/> Abbrechen</button>
              <button type="submit" className="btn btn-primary mt-4" data-bs-dismiss="modal" onClick={DelProduct}><i className="bi bi-trash"/> Entfernen</button>
            </div>
          </div>
        </div>
      </div>
    )}
    {printID !== 0 && (
      <div className="modal fade show" style={{display:"block",backgroundColor: "rgba(0,0,0,0.5)"}}>
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{GetName(printID)}Print@home</h5>
      {(progress===false || progress>95) &&              
              <button type="button" className="btn-close" onClick={handleSetPrintID(0)}></button>
      }
            </div>
            <div className="modal-body">
    {progress!==false &&
      <p>
        {numPrint>1 && <span>Mehrfachdruck: <span className="highlight">{numPrint}</span> </span>}<br/>
        Stift: <span className="highlight">{Pens.find(p => p.value===userinfo.lastpen).text}</span><br/>
        Grösse: <span className="highlight">{(hasImage?sizesImg:sizesSticker).find(p => p.value===size)?.text}</span><br/>
        Printmodus: <span className="highlight">{userinfo.printmode}</span><br/>
        {hasImage && <span>Aufhellen: <span className="highlight">{hell==='0'?'Standard':hell==='1'?'Hell':hell==='2'?'Sehr hell':''}</span></span>}
      </p>
    }
    {progress===false &&
      <>
      {!hasImage &&
              <div className="mb-3">
                <label htmlFor="numprint" className="form-label">Wähle wie oft du dein Projekt drucken möchtest. Damit füllst du die Etikettenbogen!</label>
                <select className="form-select" value={numPrint} onChange={handleNumPrint} id="numprint" style={{width:'10em'}}>
        {[...Array(29)].map((e, i) =>
                  <option key={i+1} value={i+1}>{i+1}</option>
        )}
                </select>
              </div>
      }
              <div className="mb-3">
                <label htmlFor="homepen" className="form-label">Wähle für welchen Stift du drucken möchtest:</label>
                <select className="form-select" value={userinfo.lastpen} onChange={handlePen} id="homepen" style={{width:'10em'}}>
        {Pens.map((p) =>
                  <option key={p.value} value={p.value}>{p.text}</option>
        )}
                </select>
              </div>
      {!hasImage &&
              <div className="mb-3">
                <label htmlFor="homepen" className="form-label">Wähle in welcher Grösse / Form du deine Soundsticker brauchst:</label>
                <select className="form-select" value={size} onChange={handleSize} id="size" style={{width:'13em'}}>
        {sizesSticker.map((p) =>
                  <option key={p.value} value={p.value}>{p.text}</option>
        )}
                </select>
              </div>
      }
      {hasImage &&
       <>
              <div className="mb-3">
                <label htmlFor="homepen" className="form-label">Wähle die Anordnung / Grösse deiner Symbole auf dem A4 Blatt:</label>
                <select className="form-select" value={size} onChange={handleSize} id="size" style={{width:'13em'}}>
        {sizesImg.map((p) =>
                  <option key={p.value} value={p.value}>{p.text}</option>
        )}
                </select>
              </div>
              <div className="d-flex">
                <div className="mb-3">
                  <label htmlFor="homepen" className="form-label">Aufhellen Schwarz</label>
                  <select className="form-select" value={hell} onChange={handleHell} id="size" style={{width:'13em'}}>
                    <option value="0">standard</option>
                    <option value="1">hell</option>
                    <option value="2">sehr hell</option>
                  </select>
                </div>
              </div>
        </>
      }
              {(userinfo.printmode==='' || userinfo.printmode==='0') && <h6>Vor deinem ersten Print@Home musst du den Printmodus bestimmen.<br/>
                Die Anleitung dazu findest du <a href="/tipps/112">hier</a></h6>}
              <div className="mb-3">
                <label htmlFor="homemode" className="form-label">Wähle den passenden Printmodus für deinen Drucker:</label>
                <select className="form-select" value={userinfo.printmode} onChange={handlePrintMode} id="homemode" style={{width:'10em'}}>
                  <option key={0} value={0}>Bitte wählen</option>
        {PrintModi.map((p) =>
                  <option key={p} value={p}>{p}</option>
        )}
                </select>
              </div>
        {(userinfo.email==='info@soundolino.ch' || userinfo.email.slice(-10)==='@alixon.ch')  &&
              <div className="mb-3">
                <label htmlFor="formGroupExampleInput" className="form-label">Extra Param</label>
                <input type="text" value={extraParam} onChange={handleExtraParam} className="form-control" style={{width:'10em'}} /> &growY=[mm] / &multi=x / &bookii1=1 / &kanal=x
              </div>
        }
        </>
    }
              <div className="d-flex justify-content-between">
        {userinfo.lastpen!=='-' && userinfo.printmode!=='' && userinfo.printmode!=='0' && progress===false &&              
                <button className="btn btn-primary" onClick={()=>pdfErstellen()}><i className="bi bi-printer"/> PDF erstellen</button>
        }       
        {userinfo.lastpen!=='-' && userinfo.printmode!=='' && userinfo.printmode!=='0' && progress===false && hasImage &&
                <button className="btn btn-secondary" onClick={()=>pdfErstellen(true)}><i className="bi bi-eye"/> Vorschau erstellen</button>
        }       
              </div>
        {progress!==false &&
              <div className="progress" role="progressbar" style={{height: "30px"}}>
                <div className="progress-bar" style={{width: progress+"%"}}>{progress}%</div>
              </div>              
        }
        {download!==false &&
          <>
          {!hasImage &&
              <a href={'https://'+dataprovider.apiUrl+"/download/"+download.id+".pdf"} target="_blank" rel="noreferrer" className="btn btn-primary mt-4" onClick={handleSetPrintID(0)}><i className="bi bi-printer"/> PDF herunterladen</a>
          }
          {hasImage &&
            <>
                <a href={'https://'+dataprovider.apiUrl+"/download/"+download.id+"_cmy.pdf"} target="_blank" rel="noreferrer" className="btn btn-primary mt-4 ms-2"><i className="bi bi-printer"/> PDF {download.preview ? 'Vorschau' : 'Farb (zuerst drucken)'}</a>
            {!download.preview &&
                <a href={'https://'+dataprovider.apiUrl+"/download/"+download.id+"_k.pdf"} target="_blank" rel="noreferrer" className="btn btn-primary mt-4 ms-2"><i className="bi bi-printer"/> PDF Schwarz (darüber drucken)</a>
            }
            </>
          }
          </>
        }
            </div>
          </div>
        </div>
      </div>
    )}
    {addCart > 0 && (
      <div className="modal fade show" style={{display:"block",backgroundColor: "rgba(0,0,0,0.5)"}}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{GetName(addCart)}Print on Demand</h5>
              <button type="button" className="btn-close" onClick={handleSetAddCart(0)}></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label htmlFor="formGroupExampleInput" className="form-label">Wähle für welchen Stift du die Sticker bestellen möchtest?</label>
                <select value={userinfo.lastpen} onChange={handlePen} className="form-select" aria-label="Stift Typ" style={{width:'10em'}}>
            {Pens.map((p) =>
                  <option key={p.value} value={p.value}>{p.text}</option>
            )}
                </select>
              </div>
      {!hasImage &&
              <div className="mb-3">
                <label htmlFor="homepen" className="form-label">Wähle in welcher Grösse / Form du deine Soundsticker brauchst:</label>
                <select className="form-select" value={size} onChange={handleSize} id="size" style={{width:'13em'}}>
        {sizesSticker.map((p) =>
                  <option key={p.value} value={p.value}>{p.text}</option>
        )}
                </select>
              </div>
      }
      {hasImage &&
              <div className="mb-3">
                <label htmlFor="homepen" className="form-label">Wähle die Anordnung / Grösse deiner Symbole auf dem A4 Blatt:</label>
                <select className="form-select" value={size} onChange={handleSize} id="size" style={{width:'13em'}}>
        {sizesImg.map((p) =>
                  <option key={p.value} value={p.value}>{p.text}</option>
        )}
                </select>
              </div>
      }
              <div className="mb-3">
                <label htmlFor="formGroupExampleInput" className="form-label">Wähle wie oft du dein Projekt benötigst.</label>
                <input type="number" value={anz} min="1" onChange={handleAnz} className="form-control" id="formGroupExampleInput" placeholder="Example input placeholder" style={{width:'5em'}} />
              </div>
              <div className="mb-3">
      {!hasImage &&
                <div>{anzSticker} Soundsticker ({anzBogen} Bogen à CHF 4.90) = CHF {(4.9 * anzBogen).toFixed(2)}</div>
      }
      {hasImage &&
                <div>{anzSticker} Symbole ({anzBogen} Bogen à CHF 4.90) = CHF {(4.9 * anzBogen).toFixed(2)}</div>
      }
              </div>
        {progress!==false &&
              <div className="progress" role="progressbar" style={{height: "30px"}}>
                <div className="progress-bar" style={{width: progress+"%"}}>{progress}%</div>
              </div>              
        }
              <div className="d-flex justify-content-between">
                <button type="button" className="btn btn-primary mt-4" onClick={handleAddCart}><i className="bi bi-cart"/> In den Warenkorb</button>
                {!download.preview &&
                  <button className="btn btn-secondary mt-4" onClick={()=>pdfErstellen(true)}><i className="bi bi-eye"/> Vorschau erstellen</button>
                }
                {download.preview &&
                  <a href={'https://'+dataprovider.apiUrl+"/download/"+download.id+(!hasImage?".pdf":"_cmy.pdf")} 
                    target="_blank" rel="noreferrer" className="btn btn-primary mt-4 ms-2" onClick={()=>setDownload(false)}>
                    <i className="bi bi-printer"/> PDF Vorschau
                  </a>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )}
    </>
  )
}

export default Biblio;
